module.exports = __webpack_public_path__ + "static/media/Collab.fd33e411.png";